export { default } from "./mutationFactory";
export { default as blockCard } from "./cards/blockCard";
export { default as activateCard } from "./cards/activateCard";
export { default as smsInfo } from "./cards/changeCardSmsInfoStatus";
export { default as setCardToPinChange } from "./cards/changeCardPin";
export { default as resetPinCounter } from "./cards/resetCardPinCounter";
export { default as changeCardPhone } from "./cards/changeCardPhone";
export { default as addNewCardLimit } from "./cards/cardLimit/addCardLimit";
export { default as editCardLimit } from "./cards/cardLimit/editCardLimit";
export { default as deleteCardLimit } from "./cards/cardLimit/deleteCardLimit";
export { default as changeClientEmail } from "./client/changeClientEmail";
export {
  default as createServicedeskRequest,
} from "./sd/serviceDeskRequest/addServiceDeskRequest";

export { default as ssoUser } from "./users/ssoUser";
export { default as ssoUserRole } from "./users/ssoUserRole";
export { default as processingUser } from "./users/processingUser";
export { default as processingRole } from "./users/processingRole";



// WEBPACK FOOTER //
// ./src/model/gql/mutations/index.js